import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "mahai-header-inner" }
const _hoisted_2 = { class: "mahai-header-left" }
const _hoisted_3 = {
  key: 0,
  class: "mahai-header-right"
}
const _hoisted_4 = { class: "mahai-header-actions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("header", {
    id: "HeaderTheme",
    class: _normalizeClass([
      'mahai-header',
      { sticky: _ctx.isSticky },
      { active: _ctx.stateStoreInstance.open },
    ])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("button", {
          type: "button",
          class: _normalizeClass(['mahai-burger', { active: _ctx.stateStoreInstance.open }]),
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.stateStoreInstance.onChange && _ctx.stateStoreInstance.onChange(...args))),
          "aria-label": "Menüyü aç/kapat"
        }, [...(_cache[6] || (_cache[6] = [
          _createElementVNode("span", { class: "material-symbols-outlined" }, "menu", -1)
        ]))], 2)
      ]),
      _cache[12] || (_cache[12] = _createElementVNode("div", { class: "mahai-header-center" }, [
        _createElementVNode("span", { class: "mahai-header-title" }, "Yüksek Mahkeme Bilgi İşlem Merkezi - Yapay Zeka Platformu")
      ], -1)),
      (_ctx.isLawAssistantRoute)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("button", {
                type: "button",
                class: "mahai-action-btn precedent-btn",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handlePrecedentSearch && _ctx.handlePrecedentSearch(...args))),
                "aria-label": "Emsal karar ara",
                title: "Emsal Ara"
              }, [...(_cache[7] || (_cache[7] = [
                _createElementVNode("span", { class: "material-symbols-outlined" }, "search", -1)
              ]))]),
              _createElementVNode("button", {
                type: "button",
                class: "mahai-action-btn",
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleShare && _ctx.handleShare(...args))),
                "aria-label": "Sohbeti paylaş",
                title: "Paylaş"
              }, [...(_cache[8] || (_cache[8] = [
                _createElementVNode("span", { class: "material-symbols-outlined" }, "ios_share", -1)
              ]))]),
              _createElementVNode("button", {
                type: "button",
                class: "mahai-action-btn",
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.handleClear && _ctx.handleClear(...args))),
                "aria-label": "Sohbeti temizle",
                title: "Temizle"
              }, [...(_cache[9] || (_cache[9] = [
                _createElementVNode("span", { class: "material-symbols-outlined" }, "delete_sweep", -1)
              ]))]),
              _createElementVNode("button", {
                type: "button",
                class: "mahai-action-btn",
                onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.handleExportPdf && _ctx.handleExportPdf(...args))),
                "aria-label": "PDF olarak indir",
                title: "PDF İndir"
              }, [...(_cache[10] || (_cache[10] = [
                _createElementVNode("span", { class: "material-symbols-outlined" }, "picture_as_pdf", -1)
              ]))]),
              _createElementVNode("button", {
                type: "button",
                class: "mahai-action-btn",
                onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.handleExportWord && _ctx.handleExportWord(...args))),
                "aria-label": "Word olarak indir",
                title: "Word İndir"
              }, [...(_cache[11] || (_cache[11] = [
                _createElementVNode("span", { class: "material-symbols-outlined" }, "description", -1)
              ]))])
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ], 2))
}